// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pk12x7{margin-top:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
